import { ErrorNotfound } from '~/components/errors/error-notfound';

export default function Custom404() {
  return <ErrorNotfound />;
}
